import * as fb from "@/firebase";
// import { auth } from "../../firebase";
// import { db } from "@/firebase";
import {
  GET_REPORTS,
  UNSUBSCRIBE_REPORTS,
  GET_ARCHIVED_REPORTS,
  // CREATE_REPORT,
  // UPDATE_REPORT,
  GET_REPORT_TYPES,
  CREATE_REPORT_TYPE,
  CREATE_REPORT_TYPES,
  UPDATE_REPORT_TYPE,
  DELETE_REPORT_TYPE,
  UPDATE_DUTY_MANAGEMENT_CONFIG,
} from "../action-types";
import {
  SET_REPORTS,
  SET_REPORTS_UNSUBSCRIBE,
  CLEAR_REPORTS_LISTENER,
  SET_ARCHIVED_REPORTS,
  SET_REPORT_TYPES,
  SET_LOADING,
} from "../mutation-types";
export default {
  namespaced: true,

  state: {
    reports: [],
    reportsUnsubscribe: null,
    archivedReports: [],
    dutyTypes: [],
    loading: false,
  },

  mutations: {
    [SET_REPORTS](state, payload) {
      state.reports = payload;
    },
    [SET_REPORTS_UNSUBSCRIBE](state, unsubscribe) {
      state.reportsUnsubscribe = unsubscribe;
    },
    [CLEAR_REPORTS_LISTENER](state) {
      if (state.reportsUnsubscribe) {
        state.reportsUnsubscribe();
        state.reportsUnsubscribe = null;
      }
      state.reports = [];
    },
    [SET_ARCHIVED_REPORTS](state, payload) {
      state.archivedReports = payload;
    },
    [SET_REPORT_TYPES](state, payload) {
      state.dutyTypes = payload;
    },
    [SET_LOADING](state, payload) {
      state.loading = payload;
    },
  },

  actions: {
    [GET_REPORTS]({ commit, state }, payload) {
      // If listener already exists with data, don't recreate
      if (state.reportsUnsubscribe && state.reports.length > 0) {
        return;
      }

      // Set loading state
      commit(SET_LOADING, true);

      // Clear existing listener before setting up a new one
      if (state.reportsUnsubscribe) {
        state.reportsUnsubscribe();
        commit(SET_REPORTS_UNSUBSCRIBE, null);
      }

      var limit = 350;
      if (payload.paginationLimit != undefined) {
        limit = payload.paginationLimit;
      }

      var baseReference = fb.organizationCollection
        .doc(payload.organizationId)
        .collection("dutyReports")
        .where("status", "in", [
          "toBeProcessed",
          "inCorrection",
          "inProgress",
          "toBeReviewed",
          "approved",
          // "rejected",
        ]);
      let reference = baseReference; // base case queries all entries
      if (payload.query.queryIsFiltered) {
        if (payload.query.filterByUid) {
          reference = reference.where("assignedTo.uid", "==", payload.uid);
        }
        if (payload.query.onlyOwn) {
          reference = reference.where(
            "assignedTo.uid",
            "==",
            fb.auth.currentUser.uid
          );
        }
      }

      // Use realtime listener instead of one-time fetch
      const unsubscribe = reference.limit(limit).onSnapshot(
        (querySnapshot) => {
          const reports = [];
          querySnapshot.forEach((doc) => {
            const object = {
              ...doc.data(),
            };
            reports.push(object);
          });
          commit(SET_REPORTS, reports);
          commit(SET_LOADING, false);
        },
        (error) => {
          console.error("Error listening to reports:", error);
          commit(SET_LOADING, false);
        }
      );

      // Store the unsubscribe function
      commit(SET_REPORTS_UNSUBSCRIBE, unsubscribe);
    },

    [UNSUBSCRIBE_REPORTS]({ commit, state }) {
      if (state.reportsUnsubscribe) {
        state.reportsUnsubscribe();
        commit(SET_REPORTS_UNSUBSCRIBE, null);
        commit(SET_REPORTS, []);
      }
    },
    [GET_ARCHIVED_REPORTS]({ commit }, payload) {
      const archivedReports = [];
      var limit = 800;
      if (payload.paginationLimit != undefined) {
        limit = payload.paginationLimit;
      }

      fb.organizationCollection
        .doc(payload.organizationId)
        .collection("dutyReports")
        .where("status", "in", payload.query.status)
        // .where("type.id", "in", payload.query.types)
        // .where(
        //   "assignedTo.uid",
        //   "==",
        //   payload.query.assignedTo.uid
        // )
        .where(
          "duration.start.timestamp",
          ">=",
          fb.Timestamp.fromDate(new Date(payload.query.range.start))
        )
        .where(
          "duration.start.timestamp",
          "<=",
          fb.Timestamp.fromDate(new Date(payload.query.range.end))
        )
        .orderBy("duration.start.timestamp", "asc")
        .limit(limit)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const object = {
              ...doc.data(),
            };
            archivedReports.push(object);
          });
          console.log(archivedReports);
          return commit(SET_ARCHIVED_REPORTS, archivedReports);
        })
        .catch((error) => console.log(error));
    },

    [GET_REPORT_TYPES]({ commit }, payload) {
      return new Promise((resolve, reject) => {
        const data = [];
        let baseReference = fb.organizationCollection
          .doc(payload.organizationId)
          .collection("dutyTypes");
        var dbRef = baseReference;

        // If payload.onlyActive is true, filter by isActive
        if (payload.query?.onlyActive) {
          dbRef = dbRef.where("isActive", "==", true);
        }

        dbRef
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              data.push(doc.data());
            });
            data.sort((a, b) => parseFloat(a.sortKey) - parseFloat(b.sortKey));
            commit(SET_REPORT_TYPES, data);
            resolve(querySnapshot);
          })
          .catch((error) => {
            console.log("Error getting document:", error);
            reject(error);
          });
      });
    },

    [CREATE_REPORT_TYPE]({ commit }, payload) {
      commit(SET_LOADING, true);
      const docRef = fb.organizationCollection
        .doc(payload.organizationId)
        .collection("dutyTypes")
        .doc();
      docRef
        .set({
          title: payload.title,
          shortTitle: payload.shortTitle,
          description: payload.description,
          icon: payload.icon,
          color: payload.color,
          sortKey: payload.sortKey,
          isActive: payload.isActive,
          organizationId: payload.organizationId,
          prefill: {
            title: payload.prefill.title,
            location: payload.prefill.location,
            payrollType: {
              id: payload.prefill.payrollType.id,
              title: payload.prefill.payrollType.title,
            },
          },
          options: {
            requiredFields: payload.options.requiredFields,
            customFields: payload.options.customFields,
          },
          approvalWorkflow: {
            type: payload.approvalWorkflow.type || "defaultProcess",
            process: payload.approvalWorkflow.process || [],
          },
          meta: {
            id: docRef.id,
            createdBy: fb.auth.currentUser.uid,
            createdAt: fb.FieldValue.serverTimestamp(),
          },
        })
        .catch((error) => console.log(error));
      commit(SET_LOADING, false);
    },

    [CREATE_REPORT_TYPES]({ commit }, payload) {
      var batch = fb.db.batch();
      const batchRef = fb.db
        .collection("organizations")
        .doc(payload.organizationId)
        .collection("dutyTypes");

      payload.dutyTypes.forEach(function (dutyType) {
        const newDocRef = batchRef.doc();
        const object = {
          ...dutyType,
          organizationId: payload.organizationId,
          meta: {
            id: newDocRef.id,
            createdBy: fb.auth.currentUser.uid,
            createdAt: fb.FieldValue.serverTimestamp(),
          },
        };
        batch.set(newDocRef, object);
      });
      batch
        .commit()
        .then(() => {
          return commit(SET_LOADING, false);
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },
    [UPDATE_REPORT_TYPE]({ commit }, payload) {
      commit(SET_LOADING, true);
      fb.organizationCollection
        .doc(payload.organizationId)
        .collection("dutyTypes")
        .doc(payload.itemId)
        .update({
          title: payload.title,
          shortTitle: payload.shortTitle,
          description: payload.description,
          color: payload.color,
          icon: payload.icon,
          isActive: payload.isActive,
          sortKey: payload.sortKey,
          "prefill.title": payload.prefill.title,
          "prefill.location": payload.prefill.location,
          "prefill.payrollType": payload.prefill.payrollType,
          "options.requiredFields": payload.options.requiredFields,
          "options.customFields": payload.options.customFields,
          approvalWorkflow: {
            type: payload.approvalWorkflow.type || "defaultProcess",
            process: payload.approvalWorkflow.process || [],
          },

          "meta.lastUpdatedAt": fb.FieldValue.serverTimestamp(),
          "meta.lastUpdatedBy": fb.auth.currentUser.uid,
        })
        .catch((error) => console.log(error));
      commit(SET_LOADING, false);
    },

    [DELETE_REPORT_TYPE]({ commit }, payload) {
      commit(SET_LOADING, true);
      const docRef = fb.organizationCollection
        .doc(payload.organizationId)
        .collection("dutyTypes")
        .doc(payload.itemId);
      docRef.delete().catch((error) => console.log(error));
      commit(SET_LOADING, false);
    },

    [UPDATE_DUTY_MANAGEMENT_CONFIG]({ commit }, payload) {
      commit(SET_LOADING, true);
      let updateData = {};

      if (payload.type === "onlyStaleReportReminderConfig") {
        updateData = {
          "config.dutyManagement.staleReportReminder.isActive":
            payload.staleReportReminder.isActive,
          "config.dutyManagement.staleReportReminder.thresholdHours":
            payload.staleReportReminder.thresholdHours,
          "config.dutyManagement.staleReportReminder.reminderIntervalDays":
            payload.staleReportReminder.reminderIntervalDays,
          "config.dutyManagement.staleReportReminder.additionalNotifyPersons":
            payload.staleReportReminder.additionalNotifyPersons,
        };
      }

      fb.organizationCollection
        .doc(payload.organizationId)
        .update({
          ...updateData,
          "meta.lastUpdatedAt": fb.FieldValue.serverTimestamp(),
          "meta.lastUpdatedBy": fb.auth.currentUser.uid,
        })
        .catch((error) => console.log(error));
      commit(SET_LOADING, false);
    },
  },

  getters: {},
};
